import { render, staticRenderFns } from "./AssignmentCreateDetail.vue?vue&type=template&id=af59429e&scoped=true&"
import script from "./AssignmentCreateDetail.vue?vue&type=script&lang=js&"
export * from "./AssignmentCreateDetail.vue?vue&type=script&lang=js&"
import style0 from "./AssignmentCreateDetail.vue?vue&type=style&index=0&id=af59429e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af59429e",
  null
  
)

export default component.exports